import { Grid } from '@mui/material';
import React from 'react';
import { APP_ROUTES } from '../../../common/constants/Routes';
import { useForm } from 'react-hook-form';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { useNavigate } from 'react-router-dom';
import Header from '../../../common/Header';
import DispenserFrom from './DispenserFrom';
import { useTranslation } from 'react-i18next';

function AddDispenser() {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      dispenser_type: '',
      bunk_details_id: '',
    },
  });
  const navigate = useNavigate();
  const onSubmit = (data: any) => {
    console.log(data);
    navigate(APP_ROUTES.DISPENSER);
  };

  return (
    <Grid container mb={5}>
      <Grid xs={12} p={2}>
        <Header
          view={true}
          header={t('ADD_DISPENSER')}
          route={APP_ROUTES.DISPENSER}
          buttonName={t('GO_BACK')}
          buttonIcon={SubdirectoryArrowRightIcon}
        />
      </Grid>
      <Grid xs={12}>
        <DispenserFrom
          reset={reset}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          control={control}
          register={register}
          errors={errors}
          watch={watch}
          setValue={setValue}
        />
      </Grid>
    </Grid>
  );
}

export default AddDispenser;
